import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable, interval, map, share, shareReplay } from 'rxjs'
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface'
import { DashboardHome } from 'src/app/shared/interfaces/dashboard/dashboard-home.interface'
import { DashboardStats } from 'src/app/shared/interfaces/dashboard/dashboard-stats.interface'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class DashboardHomeService {
    #httpclient = inject(HttpClient)

    getDashboardStats(): Observable<DashboardStats> {
        return this.#httpclient
            .get<ApiResponse<DashboardStats>>(`${environment.baseUrl}dashboard/stats`)
            .pipe(map((x) => x.result))
    }

    getDashboardHome(): Observable<DashboardHome> {
        return this.#httpclient
            .get<ApiResponse<DashboardHome>>(`${environment.baseUrl}dashboard/home`)
            .pipe(map((x) => x.result))
    }
}
